import * as actionTypes from "../actionTypes/Index";
import { productCityLevelInitialState } from "./InitialState";
import { IActionType } from "../../interfaces/Index";

const initialState = { ...productCityLevelInitialState };

export const appendUpdateProductsCityLevel = (payload: any, state: any) => {
  if (payload.isPaginatedRes) {
    return [...state.productsCityLevel, ...payload.productCityLevelData];
  }
  return payload.productCityLevelData.slice();
};

export default function productCityLevelReducer(
  state = initialState,
  action: IActionType
) {
  switch (action.type) {
    case actionTypes.GET_PRODUCTS_CITY_LEVEL_INIT: {
      return Object.assign({}, state, {
        isFetchProductCityLevelLoading: true,
        isFetchProductCityLevelError: false,
        isProductCityLevelAdded: false,
        isProductCityLevelUpdated: false,
        isProductCityLevelBulkUploaded: false,
        isProductCityLevelInventoryUploaded: false,
        isProductCityLevelDetailsFetched: false,
        error: null,
        isError: false,
      });
    }
    case actionTypes.GET_PRODUCTS_CITY_LEVEL_SUCCESS: {
      return Object.assign({}, state, {
        isFetchProductCityLevelLoading: false,
        productsCityLevel: appendUpdateProductsCityLevel(action.payload, state),
        pagination: (action.payload! as any).pagination,
      });
    }
    case actionTypes.GET_PRODUCTS_CITY_LEVEL_FAIL: {
      return Object.assign({}, state, {
        isFetchProductCityLevelLoading: false,
        isFetchProductCityLevelError: true,
        error: action.error,
      });
    }
    case actionTypes.GET_PRODUCTS_CITY_LEVEL_DETAILS_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        isProductCityLevelAdded: false,
        isProductCityLevelBulkUploaded: false,
        isProductCityLevelInventoryUploaded: false,
        isProductCityLevelDetailsFetched: false,
        productCityLevelDetails: {},
      });
    }
    case actionTypes.GET_PRODUCTS_CITY_LEVEL_DETAILS_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isProductCityLevelDetailsFetched: true,
        productCityLevelDetails: action.payload,
      });
    }
    case actionTypes.GET_PRODUCTS_CITY_LEVEL_DETAILS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: action.error,
      });
    }
    case actionTypes.CLEAR_PRODUCT_CITY_LEVEL_DETAILS: {
      return Object.assign({}, state, {
        productCityLevelDetails: [],
        isProductCityLevelDetailsFetched: false,
        isProductCityLevelUpdated: false,
        isError: false,
        error: null,
      });
    }
    case actionTypes.BULK_UPLOAD_INIT: {
      return Object.assign({}, state, {
        isProductCityLevelBulkUploading: true,
        isProductCityLevelBulkUploadingError: false,
        isProductCityLevelBulkUploaded: false,
        isProductCityLevelDetailsFetched: false,
        error: null,
      });
    }
    case actionTypes.BULK_UPLOAD_SUCCESS: {
      return Object.assign({}, state, {
        isProductCityLevelBulkUploading: false,
        isProductCityLevelBulkUploaded: true,
      });
    }
    case actionTypes.BULK_UPLOAD_FAIL: {
      return Object.assign({}, state, {
        isProductCityLevelBulkUploading: false,
        isProductCityLevelBulkUploadingError: true,
        isProductCityLevelBulkUploaded: false,
        error: action.error,
      });
    }
    case actionTypes.INVENTORY_UPLOAD_INIT: {
      return Object.assign({}, state, {
        isProductCityLevelInventoryUploading: true,
        isProductCityLevelInventoryUploadingError: false,
        isProductCityLevelInventoryUploaded: false,
        isProductCityLevelDetailsFetched: false,
        error: null,
      });
    }
    case actionTypes.INVENTORY_UPLOAD_SUCCESS: {
      return Object.assign({}, state, {
        isProductCityLevelInventoryUploading: false,
        isProductCityLevelInventoryUploaded: true,
      });
    }
    case actionTypes.INVENTORY_UPLOAD_FAIL: {
      return Object.assign({}, state, {
        isProductCityLevelInventoryUploading: false,
        isProductCityLevelInventoryUploadingError: true,
        isProductCityLevelInventoryUploaded: false,
        error: action.error,
      });
    }
    case actionTypes.NEW_CITY_LEVEL_PRODUCT_PRICE_UPLOAD_INIT: {
      return Object.assign({}, state, {
        isNewCityLevelProductPricesUploading: true,
        isNewCityLevelProductPricesUploadingError: false,
        isNewCityLevelProductPricesUploaded: false,
        isProductCityLevelDetailsFetched: false,
        error: null,
      });
    }
    case actionTypes.NEW_CITY_LEVEL_PRODUCT_PRICE_UPLOAD_SUCCESS: {
      return Object.assign({}, state, {
        isNewCityLevelProductPricesUploading: false,
        isNewCityLevelProductPricesUploaded: true,
      });
    }
    case actionTypes.NEW_CITY_LEVEL_PRODUCT_PRICE_UPLOAD_FAIL: {
      return Object.assign({}, state, {
        isNewCityLevelProductPricesUploading: false,
        isNewCityLevelProductPricesUploadingError: true,
        isNewCityLevelProductPricesUploaded: false,
        error: action.error,
      });
    }
    case actionTypes.UPDATE_PRODUCT_CITY_LEVEL_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isProductCityLevelUpdated: false,
        error: null,
        isProductCityLevelAdded: false,
        isProductCityLevelBulkUploaded: false,
        isProductCityLevelInventoryUploaded: false,
      });
    }
    case actionTypes.UPDATE_PRODUCT_CITY_LEVEL_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isProductCityLevelUpdated: true,
        productCityLevelDetails: [],
        isProductCityLevelDetailsFetched: false,
      });
    }
    case actionTypes.UPDATE_PRODUCT_CITY_LEVEL_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isProductCityLevelUpdated: false,
        error: action.error,
      });
    }
    case actionTypes.GET_PRODUCT_CITY_LEVEL_BRANDS_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        productCityLevelBrands: [],
      });
    }
    case actionTypes.GET_PRODUCT_CITY_LEVEL_BRANDS_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        isError: false,
        productCityLevelBrands: action.payload,
      });
    }
    case actionTypes.GET_PRODUCT_CITY_LEVEL_BRANDS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
        productCityLevelBrands: [],
        isError: true,
      });
    }
    case actionTypes.GET_WAREHOUSE_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        wareHouseNames: [],
      });
    }
    case actionTypes.GET_WAREHOUSE_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        isError: false,
        wareHouseNames: (action.payload as any).slice(),
      });
    }
    case actionTypes.GET_WAREHOUSE_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
        wareHouseNames: [],
        isError: true,
      });
    }

    case actionTypes.GET_DELIVERY_OPTIONS_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        deliveryOptions: [],
      });
    }
    case actionTypes.GET_DELIVERY_OPTIONS_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        isError: false,
        deliveryOptions: (action.payload as any).slice(),
      });
    }

    case actionTypes.GET_DELIVERY_OPTIONS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
        deliveryOptions: [],
        isError: true,
      });
    }

    case actionTypes.GET_PRODUCT_CITY_LEVEL_INVENTORY_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        productCityLevelInventory: [],
        isProductCityLevelInventoryFetched: false,
      });
    }
    case actionTypes.GET_PRODUCT_CITY_LEVEL_INVENTORY_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        isError: false,
        productCityLevelInventory: (action.payload as any).slice(),
        isProductCityLevelInventoryFetched: true,
      });
    }
    case actionTypes.GET_PRODUCT_CITY_LEVEL_INVENTORY_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
        productCityLevelInventory: [],
        isError: true,
      });
    }
    case actionTypes.UPDATE_PRODUCT_CITY_LEVEL_INVENTORY_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        isProductCityLevelInventoryUpdated: false,
      });
    }
    case actionTypes.UPDATE_PRODUCT_CITY_LEVEL_INVENTORY_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isProductCityLevelUpdated: true,
        isProductCityLevelInventoryUpdated: true,
        productCityLevelInventoryDetails: [],
        isProductInventoryDetailsFetched: false,
      });
    }
    case actionTypes.UPDATE_PRODUCT_CITY_LEVEL_INVENTORY_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isProductCityLevelInventoryUpdated: false,
        error: action.error,
      });
    }
    case actionTypes.GET_ODOO_TAX_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        odooTax: null,
        isOdooTaxFetched: false,
        error: null,
      });
    }
    case actionTypes.GET_ODOO_TAX_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        odooTax: (action.payload as any).slice(),
        isOdooTaxFetched: true,
      });
    }
    case actionTypes.GET_ODOO_TAX_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        odooTax: null,
        isOdooTaxFetched: false,
        error: action.error,
      });
    }

    default:
      return state;
  }
}
